import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "alert alert-success",
  role: "alert"
}
const _hoisted_2 = {
  key: 1,
  class: "wp-newsletter-su narrow"
}
const _hoisted_3 = { class: "blurb" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "newline-mobile" }, "Never miss an article.", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = { class: "blog-title" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "blog-title" }, "Best of Patheos", -1)
const _hoisted_9 = { key: 1 }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "decorated-divider" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "newsletter-signup-msgs" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("input", {
  type: "submit",
  value: "Subscribe"
}, null, -1)
const _hoisted_14 = { class: "opt-out" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "fine-print remove-padding" }, [
  /*#__PURE__*/_createTextVNode("Please also opt me in for Exclusive Offers from Patheos’s Partners "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "/privacy-policy",
    target: "_blank"
  }, "Privacy and Data Policy")
], -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "newsletter-signup-msgs" }
const _hoisted_18 = {
  key: 0,
  class: "alert alert-warning",
  role: "alert"
}
const _hoisted_19 = {
  key: 1,
  class: "alert alert-danger",
  role: "alert"
}

import { ref, inject } from 'vue';
import { useField, useForm } from 'vee-validate';
import { NewslettersService } from '../../services/newsletters.service';
import { GTMService } from '../../services/gtm.service';
import useNewsletterSubmit from '../../composables/newsletter.composable';
import useValidators from '../../composables/validators.composable';

// inject our newsletter service

export default /*#__PURE__*/_defineComponent({
  __name: 'WordpressNarrow',
  props: {
    blogName: {
        type: String,
        default: ''
    },
    channelName: {
        type: String,
        default: ''
    },
    partner: {
        type: Boolean,
        default: false
    },
    sourceDesc: {
        type: String,
        default: ''
    },
    blogListId: {
        type: String,
        default: ''
    },
    channelListId: {
        type: String,
        default: ''
    },
    isDefaultChannel: {
        type: Boolean,
        default: false
    },
    pathUrl: {
        type: String,
        default: ''
    }
},
  setup(__props) {

const props = __props;

const newslettersService: NewslettersService | undefined = inject('NewslettersService');
const gtmService: GTMService | undefined = inject('GTMService');

const { newsletterSubmit } = useNewsletterSubmit(newslettersService, gtmService);

// Define Component Input Properties


// Component Locally Tracked Values
const submitting = ref(false);
const submitted = ref(false);
const error = ref('');
const isCookieLawZone = ref(false);

// get validators
const { isRequired, isEmail } = useValidators();
// generate validation schema
const validationSchema = {
    email: (value: string) => isRequired(value, 'Email is required') && isEmail(value),
    partners: () => true
};

// Form Configuration
const { handleSubmit, errors } = useForm({
    validationSchema,
    initialValues: {
        email: '',
        partners: !isCookieLawZone.value
    }
});

// Field Configurations
const { value: email } = useField('email');
const { value: partners } = useField('partners');

// Handle Form Submit
const submit = handleSubmit(async (form) => {
    console.log('submitting newsletter', form, props.channelListId, props.blogListId);

    // reset error message
    error.value = '';

    const newsletters = [props.blogListId];
    if (form.channel) {
        newsletters.push(props.channelListId);
    }

    // submit to newsletter service
    const { message, success } = await newsletterSubmit(
        newsletters,
        form.email,
        props.sourceDesc,
        partners.value,
        props.pathUrl
    );

    if (success) {
        submitted.value = true;
    } else {
        submitted.value = false;
        error.value = message;
    }
});

return (_ctx: any,_cache: any) => {
  return (submitted.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, " Thank you for your subscription. "))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createTextVNode(" Like This Column? "),
          _hoisted_4,
          _hoisted_5,
          _createTextVNode(" Subscribe To The "),
          _createElementVNode("span", _hoisted_6, _toDisplayString(decodeURIComponent(__props.blogName)), 1),
          (__props.isDefaultChannel)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                _createTextVNode(" and "),
                _hoisted_8,
                _createTextVNode(" newsletters. ")
              ]))
            : (_openBlock(), _createElementBlock("span", _hoisted_9, [
                _createTextVNode(" and the Patheos "),
                _createElementVNode("span", {
                  class: "blog-title",
                  innerHTML: decodeURIComponent(__props.channelName)
                }, null, 8, _hoisted_10),
                _createTextVNode(" Channel ")
              ])),
          _hoisted_11,
          _hoisted_12
        ]),
        _createElementVNode("form", {
          onSubmit: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(submit) && _unref(submit)(...args)))
        }, [
          _withDirectives(_createElementVNode("input", {
            type: "email",
            name: "email",
            placeholder: "Enter email address",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(email) ? (email).value = $event : null))
          }, null, 512), [
            [_vModelText, _unref(email)]
          ]),
          _hoisted_13
        ], 32),
        _withDirectives(_createElementVNode("div", _hoisted_14, _hoisted_16, 512), [
          [_vShow, isCookieLawZone.value]
        ]),
        _createElementVNode("div", _hoisted_17, [
          (_unref(errors).email)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_unref(errors).email), 1))
            : _createCommentVNode("", true),
          (error.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(error.value), 1))
            : _createCommentVNode("", true)
        ])
      ]))
}
}

})